import { jsx as _jsx } from "react/jsx-runtime";
import { HomeOutlined } from "@ant-design/icons";
import { Icon } from "@devowl-wp/react-folder-tree";
const ICON_OBJ_FOLDER_CLOSED = /*#__PURE__*/ _jsx(Icon, {
    type: "folder"
});
const ICON_OBJ_FOLDER_OPEN = /*#__PURE__*/ _jsx(Icon, {
    type: "folder-open"
});
const ICON_OBJ_FOLDER_COLLECTION = /*#__PURE__*/ _jsx("i", {
    className: "rmlicon-collection"
});
const ICON_OBJ_FOLDER_GALLERY = /*#__PURE__*/ _jsx("i", {
    className: "rmlicon-gallery"
});
const ICON_OBJ_HOME = /*#__PURE__*/ _jsx(HomeOutlined, {});
function resolveIcon(icon) {
    switch(icon){
        case "folder":
            return ICON_OBJ_FOLDER_CLOSED;
        case "folder-open":
            return ICON_OBJ_FOLDER_OPEN;
        case "collection":
            return ICON_OBJ_FOLDER_COLLECTION;
        case "gallery":
            return ICON_OBJ_FOLDER_GALLERY;
        case "home":
            return ICON_OBJ_HOME;
        default:
            {
                if (typeof icon !== "string") {
                    return icon;
                }
                return /*#__PURE__*/ _jsx(Icon, {
                    type: icon
                });
            }
    }
}
export { ICON_OBJ_FOLDER_CLOSED, ICON_OBJ_FOLDER_OPEN, ICON_OBJ_FOLDER_COLLECTION, ICON_OBJ_FOLDER_GALLERY, resolveIcon };
